import React from 'react';

import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { ExistingStudentWidgetProps } from '../Widget';
import { NoteColorTheme, TextType, TextWidget as TextWidgetModel } from '@ael/core-api';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import './TextWidget.scss';

export const NoteTypeToClassName: Record<NoteColorTheme, { icon: string; box: string }> = {
  [NoteColorTheme.default]: { box: 'uno-border-grey-700 uno-bg-background', icon: 'uno-text-grey-600' },
  [NoteColorTheme.sky]: { box: 'uno-border-sky uno-bg-sky uno-bg-op-20', icon: 'uno-text-sky' },
  [NoteColorTheme.blueberry]: { box: 'uno-border-blueberry uno-bg-blueberry uno-bg-op-20', icon: 'uno-text-blueberry' },
  [NoteColorTheme.jelly]: { box: 'uno-border-jelly uno-bg-jelly uno-bg-op-20', icon: 'uno-text-jelly' },
  [NoteColorTheme.cherry]: { box: 'uno-border-cherry uno-bg-cherry uno-bg-op-20', icon: 'uno-text-cherry' },
  [NoteColorTheme.tangerine]: { box: 'uno-border-tangerine uno-bg-tangerine uno-bg-op-20', icon: 'uno-text-tangerine' },
  [NoteColorTheme.basil]: { box: 'uno-border-basil uno-bg-basil uno-bg-op-20', icon: 'uno-text-basil' },
};

export const TextWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const textWidget = (widget as TextWidgetModel).value;

  return (
    <StudentWidgetWrapper>
      <div
        className={classNames(
          {
            'uno-flex uno-border-2 uno-border-rounded uno-border-solid uno-p-5 uno-p-l-0':
              textWidget.properties?.type === TextType.note,
          },
          textWidget.properties?.type === TextType.note && NoteTypeToClassName[textWidget.properties?.color].box
        )}
      >
        {textWidget.properties?.type === TextType.note && (
          <div
            className={classNames(
              'uno-flex uno-justify-center uno-w-25 uno-h-full uno-p-t-2.5',
              NoteTypeToClassName[textWidget.properties?.color].icon
            )}
          >
            <FontAwesomeIcon className="h-6 w-6" icon={solid('circle-info')} />
          </div>
        )}
        <div
          className={classNames('student-text-widget', textWidget.properties?.type === TextType.note && 'uno-w-full')}
          dangerouslySetInnerHTML={{ __html: textWidget.data.text }}
        />
      </div>
    </StudentWidgetWrapper>
  );
};
